import axios from '../utils/ajax'
// 订单列表
export const thailandOrderManage = params => axios.get('/managementPlatform/thailand/thailandOrderManage',{params})
// 订单详情
export const thailandOrderManageDetail = params => axios.get('/managementPlatform/thailand/thailandOrderManageDetail',{params})



// WEBPACK FOOTER //
// ./src/api/orderManagement.js